import { render, staticRenderFns } from "./WidgetAction.vue?vue&type=template&id=605fa9d7&scoped=true&"
import script from "./WidgetAction.vue?vue&type=script&lang=js&"
export * from "./WidgetAction.vue?vue&type=script&lang=js&"
import style0 from "./WidgetAction.vue?vue&type=style&index=0&id=605fa9d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605fa9d7",
  null
  
)

export default component.exports